<template>
  <div>
    <IntegrationPresetsLoader @loaded="presets = $event" />
    <IntegrationConnectionsLoader :account-id="accountId" @loaded="connections = $event" />

    <InstalledIntegration
      v-for="integration in installed"
      :key="integration.id"
      :preset="integration.preset"
      :connection="integration.connection"
      class="shadow-1 q-my-md"
      @update:connection="update"
    />

    <InstallableIntegration
      v-for="preset in installablePresets"
      :key="preset.type"
      :account-id="accountId"
      :preset="preset"
      class="shadow-1 q-my-md"
      @installed="connections.push($event)"
    />

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IntegrationPreset, IntegrationConnection } from '@/iam/types';
import IntegrationPresetsLoader from './preset/IntegrationPresetsLoader.vue';
import InstallableIntegration from './InstallableIntegration.vue';
import InstalledIntegration from './InstalledIntegration.vue';
import IntegrationConnectionsLoader from './connection/IntegrationConnectionsLoader.vue';

interface InstalledIntegrationItem {
  preset: IntegrationPreset,
  connection: IntegrationConnection
}

interface Data {
  presets: IntegrationPreset[],
  connections: IntegrationConnection[]
}

export default defineComponent({
  components: {
    IntegrationConnectionsLoader,
    IntegrationPresetsLoader,
    InstallableIntegration,
    InstalledIntegration,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      presets: [],
      connections: [],
    };
  },
  computed: {
    installablePresets(): IntegrationPreset[] {
      return this.presets.filter(
        p => !this.connections.find(c => c.serviceAccount.integrationType === p.type),
      );
    },
    installed(): InstalledIntegrationItem[] {
      const installed:InstalledIntegrationItem[] = [];
      this.connections.forEach((c) => {
        const preset = this.presets.find(p => p.type === c.serviceAccount.integrationType);
        if (preset) {
          installed.push({
            preset,
            connection: c,
          });
        }
      });
      return installed;
    },
  },
  methods: {
    update(connection: IntegrationConnection): void {
      this.connections = this.connections.map(c => (c.id === connection.id ? connection : c));
    },
  },
});
</script>
